// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-add-event {
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 80px;
  padding-bottom: 80px;
  background: #f3f4f6;
}
.calendar-add-event__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.calendar-add-event__head__subtext {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.calendar-add-event__card {
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-top: 40px;
  display: flex;
  margin-bottom: 10px;
}
.calendar-add-event__card__left {
  width: 65%;
  border-right: 1px solid #e9e9e9;
}
.calendar-add-event__card__right {
  width: 35%;
  padding-left: 40px;
  padding-top: 100px;
  padding-right: 90px;
  padding-bottom: 90px;
}
.calendar-add-event__card__head {
  padding: 5% 5% 0% 5%;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.calendar-add-event__right-heads {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.calendar-add-event__right-body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.calendar-add-event__body {
  padding: 5%;
}
.calendar-add-event__body__date {
  display: flex;
  margin-top: 40px;
}
.calendar-add-event__body__date__left {
  width: 50%;
  display: flex;
}
.calendar-add-event__body__date__left__left {
  width: 50%;
  padding: 5px;
}
.calendar-add-event__body__date__left__right {
  width: 50%;
  padding: 5px;
  padding-top: 25px;
}
.calendar-add-event__body__date__right {
  width: 50%;
  display: flex;
}
.calendar-add-event__body__date__right__left {
  width: 50%;
  padding: 5px;
}
.calendar-add-event__body__date__right__right {
  width: 50%;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/calendar/add-event/calendar-add-event.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AACJ;AAEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAZ;AAEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAZ;AAII;EACI,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAFR;AAIQ;EACI,UAAA;EACA,+BAAA;AAFZ;AAKQ;EACI,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAHZ;AAMQ;EACI,oBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALZ;AASI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPR;AAUI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARR;AAWI;EACI,WAAA;AATR;AAWQ;EACI,aAAA;EACA,gBAAA;AATZ;AAWY;EACI,UAAA;EACA,aAAA;AAThB;AAWgB;EACI,UAAA;EACA,YAAA;AATpB;AAWgB;EACI,UAAA;EACA,YAAA;EACA,iBAAA;AATpB;AAYY;EACI,UAAA;EACA,aAAA;AAVhB;AAYgB;EACI,UAAA;EACA,YAAA;AAVpB;AAYgB;EACI,UAAA;EACA,YAAA;AAVpB","sourcesContent":[".calendar-add-event {\n    padding-left: 10%;\n    padding-right: 10%;\n    padding-top: 80px;\n    padding-bottom: 80px;\n    background: #f3f4f6;\n\n    &__head {\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n        &__subtext {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n        }\n    }\n\n    &__card {\n        background-color: #ffffff;\n        border: 1px solid #f3f5f6;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        margin-top: 40px;\n        display: flex;\n        margin-bottom: 10px;\n\n        &__left {\n            width: 65%;\n            border-right: 1px solid #e9e9e9;\n        }\n\n        &__right {\n            width: 35%;\n            padding-left: 40px;\n            padding-top: 100px;\n            padding-right: 90px;\n            padding-bottom: 90px;\n        }\n\n        &__head {\n            padding: 5% 5% 0% 5%;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 30px;\n            color: #333333;\n        }\n    }\n\n    &__right-heads {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n\n    &__right-body {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n    }\n\n    &__body {\n        padding: 5%;\n\n        &__date {\n            display: flex;\n            margin-top: 40px;\n\n            &__left {\n                width: 50%;\n                display: flex;\n\n                &__left {\n                    width: 50%;\n                    padding: 5px;\n                }\n                &__right {\n                    width: 50%;\n                    padding: 5px;\n                    padding-top: 25px;\n                }\n            }\n            &__right {\n                width: 50%;\n                display: flex;\n\n                &__left {\n                    width: 50%;\n                    padding: 5px;\n                }\n                &__right {\n                    width: 50%;\n                    padding: 5px;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
